import { RbacFeature, RbacFeatureDetails, RbacApiPermission } from '@evidentid/tprm-portal-lib/models/rbac';

type DisplayAndEmailFeatures = Extract<RbacFeature,
    | RbacFeature.displayAndEmailBrandingSettings
    | RbacFeature.displayAndEmailContactInformation
    | RbacFeature.displayAndEmailContent
    | RbacFeature.displayAndEmailSettings
>;

export const DISPLAY_AND_EMAIL_FEATURE_PERMISSIONS_MAP: Record<DisplayAndEmailFeatures, RbacFeatureDetails> = {
    [RbacFeature.displayAndEmailBrandingSettings]: {
        name: RbacFeature.displayAndEmailBrandingSettings,
        label: 'View and edit branding settings',
        requiredPermissions: [
            RbacApiPermission.configGetBrandingSettings,
            RbacApiPermission.configGetFulfillmentSettings,
            RbacApiPermission.configGetRpSettings,
            RbacApiPermission.configPatchInsuranceSettings,
            RbacApiPermission.configPutDefaultBrandingSettings,
            RbacApiPermission.configPutEmailSettings,
            RbacApiPermission.configPutRpSettings,
        ],
    },
    [RbacFeature.displayAndEmailContactInformation]: {
        name: RbacFeature.displayAndEmailContactInformation,
        label: 'View and edit contact information configurations',
        requiredPermissions: [
            RbacApiPermission.configGetRpSettings,
            RbacApiPermission.configPutSupportContactInfo,
        ],
    },
    [RbacFeature.displayAndEmailContent]: {
        name: RbacFeature.displayAndEmailContent,
        label: 'View and edit email content configurations',
        requiredPermissions: [
            RbacApiPermission.configGetRpSettings,
            RbacApiPermission.configGetFulfillmentSettings,
            RbacApiPermission.configPutFulfillmentSettings,
            RbacApiPermission.configPutTprmRequestsSettings,
        ],
    },
    [RbacFeature.displayAndEmailSettings]: {
        name: RbacFeature.displayAndEmailSettings,
        label: 'View and edit email settings',
        requiredPermissions: [
            RbacApiPermission.configGetNotificationPreferences,
            RbacApiPermission.configPutCadenceSettings,
            RbacApiPermission.configPostTestNotificationEmail,
        ],
    },
};
